import {useState, useCallback, useEffect} from "react";
import {DatePicker} from "antd";
import {FilterOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import Button from "~/components/Button";
import {SelectField, SelectUserAll} from "~/components/Forms";
import {getGroupSelectOption} from "~/utils";

function TrainingReportSearch({filter, listGroup, onChange}) {

	const [trainerOptions, setTrainerOptions] = useState([]);
	const [localFilter, setLocalFilter] = useState(filter);

	useEffect(() => {
		setLocalFilter(filter);
	}, [filter]);

	const groupOptions = Object.values(getGroupSelectOption(listGroup, 'Tất cả nhóm'));

	const dateValue = localFilter?.startFrom && localFilter?.startTo
		? [dayjs.unix(localFilter.startFrom), dayjs.unix(localFilter.startTo)]
		: null;

	const handleDateChange = useCallback((dates) => {
		setLocalFilter(prev => ({
			...prev,
			startFrom: dates ? dates[0].startOf('day').unix() : undefined,
			startTo:   dates ? dates[1].endOf('day').unix()   : undefined,
		}));
	}, []);

	const handleTrainerChange = useCallback((val) => {
		setLocalFilter(prev => ({...prev, trainerId: val || undefined}));
	}, []);

	const handleGroupChange = useCallback((val) => {
		setLocalFilter(prev => ({...prev, groupId: val || undefined}));
	}, []);

	return (
		<div className="search-bar">
			<form className="form" autoComplete="off">
				<DatePicker.RangePicker
					format="DD/MM/YYYY"
					placeholder={['Từ ngày', 'Đến ngày']}
					value={dateValue}
					onChange={handleDateChange}
					style={{height: 38}}
				/>
				<SelectUserAll
					name="trainerId"
					placeholder="Nhân viên đào tạo"
					options={trainerOptions}
					setOptions={setTrainerOptions}
					onlyActive={1}
					value={localFilter?.trainerId || undefined}
					onChange={handleTrainerChange}
					label=""
					errors={{}}
					allowClear
				/>
				<SelectField
					placeholder="Tất cả nhóm"
					options={groupOptions}
					value={localFilter?.groupId || undefined}
					onChange={handleGroupChange}
					allowClear
				/>
				<Button primary small leftIcon={<FilterOutlined />} onClick={() => onChange(localFilter)}>
					Lọc kết quả
				</Button>
			</form>
		</div>
	);
}

export default TrainingReportSearch;
